import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
}

const KEEP = [
  'Your craft',
  'Client relationships',
  'Strategic decisions',
  'The work only you can do',
  'Growth',
  'Your time',
]

const HANDLE = [
  'Monitoring your ads',
  'Reading performance data',
  'Flagging what changed and why',
  'Morning briefing prep',
  'Tracking revenue and trials',
  'Pulling the numbers when you ask',
]

export default function LandingTwoKindsOfWork({ persona }: Props) {
  return (
    <section className="lp-section" id="two-kinds">
      <div className="lp-container">
        <div className="lp-section-header">
          <div className="lp-eyebrow">The technician trap</div>
          <h2>
            You started this because you’re great at one thing.{' '}
            <span style={{ color: persona.primary, textShadow: `0 0 40px ${persona.glow}` }}>
              Running it turned into fifteen.
            </span>
          </h2>
          <p className="lp-subtitle">
            Entrepreneurs spend 36% of their work week on admin and non-core tasks —
            roughly two full days, every week, managing the business instead of building
            it. There are only two kinds of work here. You only need to do one of them.
          </p>
        </div>

        <div className="lp-split">
          <div className="lp-card lp-split-pane lp-split-keep">
            <div className="lp-split-eyebrow">You keep</div>
            <ul className="lp-split-list">
              {KEEP.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div
            className="lp-card lp-split-pane lp-split-handle"
            style={{
              borderColor: `color-mix(in srgb, ${persona.primary} 45%, transparent)`,
              boxShadow: `0 24px 60px -28px ${persona.glow}`,
            }}
          >
            <div
              className="lp-split-eyebrow"
              style={{ color: persona.primary }}
            >
              {persona.name} handles
            </div>
            <ul className="lp-split-list" data-side="handle">
              {HANDLE.map((item) => (
                <li key={item} style={{ ['--lp-bullet' as string]: persona.primary }}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
